module.exports = __webpack_public_path__ + "images/witcher_rgba(0,0,0,0.7).98bfa19f3f9a15a0832c41561503cd26.jpg";